import {cn} from '@/modules/foundation/shared/tailwind';

function Skeleton({className, ...props}: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			className={cn('animate-pulse rounded-xs bg-gray-200', className)}
			{...props}
		/>
	);
}

export {Skeleton};
